import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=de67d18c&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de67d18c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de67d18c')) {
      api.createRecord('de67d18c', component.options)
    } else {
      api.reload('de67d18c', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=de67d18c&scoped=true", function () {
      api.rerender('de67d18c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/vocational-evaluation/tabs/appointment/Main.vue"
export default component.exports